import Joi from 'joi';
import { rutValidation } from '../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  nombre_cli: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  telefono: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  correo: Joi.string()
    .pattern(
      new RegExp(/^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i),
    )
    .error(new Error('Formato de correo inválido.')),
  oc: Joi.string()
    .min(8)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('N° de orden de compra consta de 8 o 9 dígitos')),
  cud: Joi.string().min(3).error(new Error('Cud es requerido')),
  bank: Joi.string().min(3).error(new Error('Banco es requerido')),
  accountNumber: Joi.string()
    .min(3)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('Número de cuenta es requerido')),
  rutOwner: rutValidation.rut().validateRut(),
  nameOwner: Joi.string()
    .min(3)
    .error(new Error('Nombre titular de la cuenta requerido')),
  cancelAddress: Joi.string().min(3).error(new Error('Dirección es requerido')),
  state: Joi.string().min(3).error(new Error('Región es requerido')),
  city: Joi.string().min(3).error(new Error('Comuna es requerida')),
  aurisTicketId: Joi.string(),
});
